import { Box, Container, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

import Stars from '../../assets/icons/stars.svg';
import ReviewImage1 from '../../assets/images/review-pp-1.webp';
import ReviewImage2 from '../../assets/images/review-pp-2.webp';
import ReviewImage3 from '../../assets/images/review-pp-3.webp';
import ReviewImage4 from '../../assets/images/review-pp-4.webp';
import ReviewImage5 from '../../assets/images/review-pp-5.webp';
import ReviewImage6 from '../../assets/images/review-pp-6.webp';
import { theme } from '../../theme';

export default function Section8() {
  const { t } = useTranslation();

  const reviews = [
    {
      name: t('HOME_PAGE.SECTION8.REVIEWS.0.NAME'),
      review: t('HOME_PAGE.SECTION8.REVIEWS.0.REVIEW'),
      country: t('HOME_PAGE.SECTION8.REVIEWS.0.COUNTRY'),
      image: ReviewImage1,
    },
    {
      name: t('HOME_PAGE.SECTION8.REVIEWS.1.NAME'),
      review: t('HOME_PAGE.SECTION8.REVIEWS.1.REVIEW'),
      country: t('HOME_PAGE.SECTION8.REVIEWS.1.COUNTRY'),
      image: ReviewImage2,
    },
    {
      name: t('HOME_PAGE.SECTION8.REVIEWS.2.NAME'),
      review: t('HOME_PAGE.SECTION8.REVIEWS.2.REVIEW'),
      country: t('HOME_PAGE.SECTION8.REVIEWS.2.COUNTRY'),
      image: ReviewImage3,
    },
    {
      name: t('HOME_PAGE.SECTION8.REVIEWS.3.NAME'),
      review: t('HOME_PAGE.SECTION8.REVIEWS.3.REVIEW'),
      country: t('HOME_PAGE.SECTION8.REVIEWS.3.COUNTRY'),
      image: ReviewImage4,
    },
    {
      name: t('HOME_PAGE.SECTION8.REVIEWS.4.NAME'),
      review: t('HOME_PAGE.SECTION8.REVIEWS.4.REVIEW'),
      country: t('HOME_PAGE.SECTION8.REVIEWS.4.COUNTRY'),
      image: ReviewImage5,
    },
    {
      name: t('HOME_PAGE.SECTION8.REVIEWS.5.NAME'),
      review: t('HOME_PAGE.SECTION8.REVIEWS.5.REVIEW'),
      country: t('HOME_PAGE.SECTION8.REVIEWS.5.COUNTRY'),
      image: ReviewImage6,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    lazyLoad: true,
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column' },
        justifyContent: 'center',
        alignItems: 'center',
        py: { xs: 8, md: 10 },
      }}
      maxWidth="lg"
    >
      <Stack gap={2} sx={{ width: '100%' }}>
        <Stack component={'header'} gap={2}>
          <Typography
            variant="h2"
            sx={{ fontSize: '32px', fontWeight: '600', textAlign: 'center' }}
          >
            {t('HOME_PAGE.SECTION8.TITLE')}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              fontSize: '16px',
              fontWeight: '300',
              textAlign: 'center',
              width: { xs: '100%', md: '60%' },
              margin: 'auto',
            }}
          >
            {t('HOME_PAGE.SECTION8.PARAGRAPH')}
          </Typography>
        </Stack>

        <Box sx={{ mt: 2 }}>
          <Slider
            {...settings}
            arrows={false}
            slidesToShow={3}
            slidesToScroll={3}
            dotsClass="slick-dots1 slick-thumb1"
            responsive={[
              {
                breakpoint: 960,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ]}
          >
            {reviews.map((review, index) => (
              <Box key={index}>
                <Stack
                  sx={{
                    border: '2px solid',
                    borderColor: 'primary.neutral100',
                    px: 2,
                    py: 4,
                    borderRadius: theme.shape.defaultBorderRadius,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    cursor: 'grab',
                    height: { xs: '280px', md: '300px' },
                    mx: 1.5,
                  }}
                >
                  <Stack direction={'column'} gap={2}>
                    <img
                      src={Stars}
                      alt="Stars"
                      style={{
                        maxWidth: '100%',
                        height: 'auto',
                        width: '120px',
                      }}
                      loading="lazy"
                    />
                    <Typography
                      variant="body1"
                      sx={{
                        color: 'primary.neutral800',
                        fontSize: { xs: '16px', md: '18px' },
                        fontWeight: '500',
                      }}
                    >
                      “{review.review}”
                    </Typography>
                  </Stack>
                  <Stack direction={'row'} gap={1.5}>
                    <img
                      src={review.image}
                      alt={review.name}
                      style={{
                        maxWidth: '48px',
                        height: 'auto',
                      }}
                      loading="lazy"
                    />
                    <Stack>
                      <Typography
                        variant="body1"
                        sx={{
                          color: 'primary.neutral800',
                          fontSize: '14px',
                          fontWeight: '600',
                        }}
                      >
                        {review.name}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          color: 'primary.neutral550',
                          fontSize: '13px',
                          fontWeight: '500',
                        }}
                      >
                        {review.country}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Box>
            ))}
          </Slider>
        </Box>
      </Stack>
    </Container>
  );
}
